function calculateScrollOffset(element, offset, alignment) {
  const body = document.body,
    html = document.documentElement;
  const elementRect = element.getBoundingClientRect();
  const clientHeight = html.clientHeight;
  const documentHeight = Math.max( body.scrollHeight, body.offsetHeight,
    html.clientHeight, html.scrollHeight, html.offsetHeight );
  offset = offset || 0; // additional offset to top
  let scrollPosition;
  switch(alignment) {
    case 'top': scrollPosition = elementRect.top; break;
    case 'middle': scrollPosition = elementRect.bottom - clientHeight / 2 - elementRect.height / 2; break;
    case 'bottom': scrollPosition = elementRect.bottom - clientHeight; break;
    default: scrollPosition = elementRect.bottom - clientHeight / 2 - elementRect.height / 2; break; //defaul to middle
  }
  const maxScrollPosition = documentHeight - clientHeight;
  return Math.min(scrollPosition + offset + window.pageYOffset,
    maxScrollPosition);
}

/**
 *
 * @param element
 * @param options
 * @returns {number|void}
 */
export default function (element, options = {}) {
  const {
    offset = 0,
    align = 'middle',
    behavior = 'smooth',
    scrollAlways = true,
  } = options;

  if (element === null) return;
  if (!scrollAlways) {
    const elPosition = element.getBoundingClientRect()
    const topVisible = elPosition.top + offset > 0 && elPosition.top < window.innerHeight;
    const bottomVisible = elPosition.height > window.innerHeight || elPosition.top + elPosition.height < window.innerHeight;
    if (topVisible && bottomVisible) {
      return;
    }
  }
  const scrollY = calculateScrollOffset(element, offset, align);
  return window.scrollTo({
    top: scrollY,
    behavior: behavior
  })
};
